<template>
    <div class="container">
    <div class="content-i">
        <div class="content-box">
            <div class="row justify-content-center">
                <div class="col">
                    <div class="element-wrapper">
                        <h6 class="element-header">
                            Informe os dados do seu Dr.Achei Card
                        </h6>
                        <div class="element-box">
                            <div class="col-md-6">
                                <form @submit.prevent="enviar" autocomplete="off">
                                    <h5 class="form-head">
                                        Validar Dr.Achei Card
                                    </h5>
                                    <div class="form-desc">
                                        Lembre-se informe os dados do titular do cartão 
                                    </div>

                                    
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="">CPF</label>
                                            <input autofocus required type="text" name="cpf" id="cpf" class="form-control"
                                                v-mask="'###.###.###-##'" v-model="payload.cpf">
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="">Data Nascimento</label>
                                            <input required type="tel" name="dataNascimento" id="dataNascimento"
                                              v-mask="'##/##/####'" placeholder="10/12/1985" class="form-control" 
                                              v-model="dataNascimento">
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="">Número Cartão</label>
                                            <input required type="tel" name="nrCartao" id="nrCartao" 
                                              class="form-control" v-model="payload.cartao">
                                        </div>
                                    </div>

                                    <div class="form-buttons-w">
                                        <button type="button" class="btn btn-secondary" @click="goPergunta()">Voltar</button>
                                        <button type="submit" class="btn btn-primary">Enviar</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
import moment from 'moment'

export default {
  created () {
    moment.locale('pt-br')
  },
  data () {
    return {
      dataNascimento: null,
      payload: {
        cpf: null,
        dataNascimento: null,
        cartao: null,
        telefoneCelular: null
      }
    }
  },
  methods: {
    enviar () {
      if (this.dataNascimento) {
        this.payload.dataNascimento = moment(this.dataNascimento, 'DD/MM/YYYY').toDate().getTime()
      }

      this.$store.dispatch('validaCartaoSinsaude', this.payload)
        .then((cartao) => this.$router.push({name: 'Cadastrese-usuario'}))
    },

    goPergunta () {
      this.payload = {
        cpf: null,
        dataNascimento: null,
        cartao: null
      }
      this.dataNascimento = null

      this.$router.push({name: 'Cadastrese-pergunta'})
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/cadastrese/Sinsaude.vue